import React, { useState } from 'react';
import styled from 'styled-components';
import Switch from 'react-ios-switch';

export interface SwitchInputProps {
  initialValue?: boolean | string | number;
  onChange?: (value: boolean, stringValue?: string) => void;
}

export function SwitchInput({ initialValue, onChange }: SwitchInputProps) {
  const [value, setValue] = useState<boolean>(
    initialValue === `true` || initialValue === 1 || initialValue === true,
  );

  const onSwitchChanged = (checked: boolean) => {
    setValue(checked);
    if (onChange) {
      onChange(checked, checked ? `true` : `false`);
    }
  };

  return (
    <Wrapper>
      <Switch checked={value} onChange={onSwitchChanged} />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  transform: scale(0.8);
`;
